(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
			this.headerTransparent = this.header.querySelector('.header-transparent');
				
			if(this.headerTransparent){
				const setTopPosition = () => { 
					this.headerTopPosition = this.header.offsetHeight;
					this.header.style.marginBottom = `-${this.header.offsetHeight}px`;
				}

				// setTopPosition();
				requestAnimationFrame(setTopPosition);

				let resizeTimeout;
				window.addEventListener('resize', () => {
					clearTimeout(resizeTimeout);
					resizeTimeout = setTimeout(setTopPosition, 60);
				});

				document.body.classList.add('header-transparent-active');
      } 

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			if (scrollTop === 0 ) {
				this.classList.add('header-at-top');
			} else {
				this.classList.remove('header-at-top');
			}		

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const transparentHeader = document.querySelector('.header-transparent');
    if (transparentHeader) {
      const headerHeight = transparentHeader.offsetHeight;
      transparentHeader.style.marginBottom = `-${headerHeight}px`;
    }
  });

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lo-categories"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.lo-section--categories').forEach(section => {
    const row = section.querySelector('[data-lo-category-slider]');
    const prev = section.querySelector('.lo-category-controls__button--prev');
    const next = section.querySelector('.lo-category-controls__button--next');
    if (!row || !prev || !next) return;

    const update = () => {
      const max = row.scrollWidth - row.clientWidth - 2;
      prev.disabled = row.scrollLeft <= 2;
      next.disabled = row.scrollLeft >= max;
      const hasOverflow = row.scrollWidth > row.clientWidth + 2;
      prev.hidden = !hasOverflow;
      next.hidden = !hasOverflow;
    };

    const move = direction => {
      row.scrollBy({ left: direction * Math.max(row.clientWidth * .8, 280), behavior: 'smooth' });
    };

    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lo-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const trimFooterWhitespace = () => {
      const footer = document.querySelector('.footer-group .lo-footer');
      const main = document.querySelector('main');
      if (!footer || !main) return;

      const featuredGroup = document.querySelector('.shopify-section-group-featured-group');
      if (featuredGroup) {
        const hasVisibleFeaturedSection = Array.from(featuredGroup.querySelectorAll('.shopify-section')).some((section) => {
          const rect = section.getBoundingClientRect();
          return rect.width > 0 && rect.height > 0;
        });

        if (!hasVisibleFeaturedSection) {
          featuredGroup.style.display = 'none';
          featuredGroup.style.margin = '0';
          featuredGroup.style.padding = '0';
        }
      }

      const visibleSections = Array.from(main.querySelectorAll('.shopify-section')).filter((section) => {
        const rect = section.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0;
      });
      const lastSection = visibleSections[visibleSections.length - 1];
      if (!lastSection) return;

      const spacingContainers = [
        lastSection,
        lastSection.firstElementChild,
        ...lastSection.querySelectorAll('*')
      ].filter(Boolean);

      spacingContainers.forEach((element) => {
        const styles = window.getComputedStyle(element);
        const paddingBottom = parseFloat(styles.paddingBottom);
        const marginBottom = parseFloat(styles.marginBottom);
        if (paddingBottom > 72) {
          element.style.paddingBottom = '32px';
        }
        if (marginBottom > 72) {
          element.style.marginBottom = '0';
        }
      });
    };

    const scheduleTrimFooterWhitespace = () => {
      window.requestAnimationFrame(trimFooterWhitespace);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleTrimFooterWhitespace);
    } else {
      scheduleTrimFooterWhitespace();
    }

    window.addEventListener('load', scheduleTrimFooterWhitespace);
    document.addEventListener('shopify:section:load', scheduleTrimFooterWhitespace);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lo-instagram-showcase"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var openButton = event.target.closest('[data-lo-instagram-open]');
    var closeButton = event.target.closest('[data-lo-instagram-close]');

    if (openButton) {
      var dialog = document.querySelector('[data-lo-instagram-dialog="' + openButton.getAttribute('data-lo-instagram-open') + '"]');
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      var video = dialog.querySelector('video');
      if (video) {
        video.currentTime = 0;
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function() {});
        }
      }
    }

    if (closeButton) {
      var closeDialog = closeButton.closest('[data-lo-instagram-dialog]');
      if (closeDialog) {
        closeDialog.close();
      }
    }

    if (event.target.matches('[data-lo-instagram-dialog]')) {
      event.target.close();
    }
  });

  document.addEventListener('close', function(event) {
    if (!event.target.matches('[data-lo-instagram-dialog]')) return;
    var video = event.target.querySelector('video');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["outer-reference-blog-index"] && !Shopify.designMode) return;
  try {
    
  class OuterReferenceBlogIndex extends HTMLElement {
    connectedCallback() {
      this.tabs = this.querySelectorAll('[data-blog-index-tab]');
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.handleTabClick);
      });
    }

    disconnectedCallback() {
      this.tabs?.forEach((tab) => {
        tab.removeEventListener('click', this.handleTabClick);
      });
    }

    handleTabClick = (event) => {
      const link = event.currentTarget;
      const hash = link.hash;

      if (!hash) return;

      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (!target) return;

      event.preventDefault();

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'start'
      });

      if (history.pushState) {
        history.pushState(null, '', hash);
      }
    };
  }

  if (!customElements.get('outer-reference-blog-index')) {
    customElements.define('outer-reference-blog-index', OuterReferenceBlogIndex);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-contact-methods"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-support-chat-trigger]');

    if (!trigger) {
      return;
    }

    event.preventDefault();

    if (window.Intercom) {
      window.Intercom('show');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    const trigger = event.target.closest('[data-support-chat-trigger]');

    if (!trigger) {
      return;
    }

    event.preventDefault();
    trigger.click();
  });

  } catch(e) { console.error(e); }
})();
})();
